﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import DIWViewport from '@/basics/diw.viewport';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@/controls/diw.form.validator';
import DIWDialog from '@/components/diw.dialog';
import TKTooltip from '@tk/components/tk.tooltip';
import TKQuickOrder from '@tk/components/tk.quick.order';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKClipboard from '@tk/components/tk.clipboard';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKStaticContent from '@tk/controls/tk.static.content';
import DIWStock from '@/components/diw.stock';
import DIWPrice from '@/components/diw.price';
import DIWBasketButton from '@/components/diw.basket.button';
import DIWTable from '@/components/diw.table';

import 'tippy.js/dist/tippy.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@scss/modules/basket.scss';

export default class Basket extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-table', constructor: DIWTable },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-basket-button', constructor: DIWBasketButton },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'diw-stock', constructor: DIWStock },
            { name: 'diw-price', constructor: DIWPrice },
        ]);
    }
}

new Basket();
